module.exports = __webpack_public_path__ + "img/cegep-outaouais.721f80bd.jpg";